import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const BL_TOKEN_KEY = "black_leaf_token";
export const BL_ADMIN_TOKEN_KEY = "bl_admin_token";
export const MAIN_TOKEN_KEY = "bloomkeeper.token";

// Society-scoped client (uses society passphrase JWT)
export const blClient = axios.create({ baseURL: `${BACKEND}/api` });
blClient.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(BL_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Black Leaf admin-scoped client — independent from the Heritage admin
export const adminClient = axios.create({ baseURL: `${BACKEND}/api` });
adminClient.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(BL_ADMIN_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export async function fetchBLAdmin() {
  const t = localStorage.getItem(BL_ADMIN_TOKEN_KEY);
  if (!t) return null;
  try {
    const r = await axios.get(`${BACKEND}/api/blackleaf/admin/me`, { headers: { Authorization: `Bearer ${t}` } });
    return r.data || null;
  } catch { return null; }
}
